import { i18n } from '@fs/zion-locale'

export default {
  ancestralHall: () => i18n.t('VolumeSetMetadata.ancestralHall', 'Ancestral Hall'),
  applyToAllVolumes: () =>
    i18n.t('VolumeSetMetadata.checkbox.applyToAllVolumes', 'Apply this change to all child volumes'),
  author: () => i18n.t('VolumeSetMetadata.author', 'Author'),
  clan: () => i18n.t('VolumeSetMetadata.clan', 'Clan'),
  clanBranches: () => i18n.t('VolumeSetMetadata.clanBranches', 'Clan Branches'),
  firstAncestor: () => i18n.t('VolumeSetMetadata.firstAncestor', 'First Ancestor'),
  generationPoem: () => i18n.t('VolumeSetMetadata.generationPoem', 'Generation Poem'),
  jiapuHeading: () => i18n.t('VolumeSetMetadata.jiapuHeading', 'Jiapu Information'),
  jokboHeading: () => i18n.t('VolumeSetMetadata.jokboHeading', 'Jokbo Information'),
  keizuHeading: () => i18n.t('VolumeSetMetadata.keizuHeading', 'Keizu Information'),
  migrantAncestor: () => i18n.t('VolumeSetMetadata.migrantAncestor', 'Migrant Ancestor'),
  notes: () => i18n.t('VolumeSetMetadata.notes', 'Notes'),
  subHeading: (volumeCount) =>
    i18n.t('VolumeSetMetadata.subHeading', 'Information about all {volumeCount} volumes', { volumeCount }),
  surnames: () => i18n.t('VolumeSetMetadata.surnames', 'Surnames'),
  title: () => i18n.t('VolumeSetMetadata.title', 'Title'),
  toast: (volumeSetSearch) =>
    i18n.t(
      'VolumeSetMetadata.toast',
      'If you do not see the {volumeSetSearch} you are looking for, you may need to look through the images using the View Information drop-down list to find the correct {volumeSetSearch}.',
      { volumeSetSearch }
    ),
  volumes: () => i18n.t('VolumeSetMetadata.volumes', 'Volumes'),
}
